import type { SimEvent } from '../core/events';
import {
  peekPort,
  portHasRoom,
  singleInput,
  singleOutput,
  tryPushToPort,
  tryTakeFromPort,
} from '../core/port';
import { traceUpstreamObservable } from '../core/routing';
import { unsubscribeAll } from '../core/subscription';
import { drainOutput } from './shared';
import type { MachineHandler } from './registry';

export const takeUntilHandler: MachineHandler = {
  kind: 'takeUntil',
  step({ state, machine }) {
    if (machine.kind !== 'takeUntil') return [];
    const events: SimEvent[] = [];

    drainOutput(state, machine, events);
    if (!machine.config) return events;

    const subject = state.subjects[machine.config.subjectId];
    const observable = traceUpstreamObservable(state, machine.position);
    if (subject?.fired && observable && state.subscribed) {
      unsubscribeAll(state);
      events.push({ type: 'observableUnsubscribed', observableId: observable.id });
      return events;
    }

    const inputPort = singleInput(machine.inputs);
    const outputPort = singleOutput(machine.outputs);
    const waitingId = peekPort(inputPort);
    if (waitingId !== undefined && portHasRoom(outputPort)) {
      tryTakeFromPort(inputPort);
      tryPushToPort(outputPort, waitingId);
    }

    return events;
  },
};
